<template>
  <div class="market-contract-image" :style="imageStyleModifiers"></div>
</template>

<script src="./market-contract-image.js"></script>
<style src="./market-contract-image.scss" lang="scss"></style>
